import { createEvent, restore } from "effector";

export const locationChanged = createEvent<string>();

export const $path = restore(locationChanged, window.location.pathname);
